'use strict';

import { startCase, toString } from 'lodash-es';

// lodash's .startCase also removes special characters used as delimiters
// such as in snake-case or kebab-case
// e.g. snake_case my_text to My Text
// e.g. kebab-case my-text to My Text
// e.g. camelCase myText to My Text

export default function TitleCase() {
  return function (val: any = '') {
    val = startCase(toString(val).toLowerCase());
    return val;
  };
}
